__turbopack_context__.v({
  "code": "CodeContent-module__CUv8JG__code",
  "codeBlock": "CodeContent-module__CUv8JG__codeBlock",
  "container": "CodeContent-module__CUv8JG__container",
});
